import { useAuth, useMessage } from "@/contexts";
import { UserService } from "@/domains/user";
// components
import { Button, Form, Input } from "antd";

interface TenantManageOptionsForm {
  password1: string;
  password2: string;
}

export const TenantManageOptionsPage = () => {
  const auth = useAuth();

  const [form] = Form.useForm<TenantManageOptionsForm>();

  const { messageApi } = useMessage();

  const handleFinish = async (values: TenantManageOptionsForm) => {
    if (!auth.user) return;

    try {
      await UserService.update(auth.user.id, {
        user: { password: values.password1 },
      }).run();

      form.resetFields();

      void messageApi.success("更新成功!");
    } catch (e) {
      console.log(e);
      void messageApi.success("更新失敗!");
    }
  };

  return (
    <div className="w:500 p:16 bg:white r:4">
      <h4 className="mb:24 t:center fg:secondary">系統設定</h4>

      <Form form={form} labelCol={{ span: 4 }} onFinish={handleFinish}>
        <Form.Item required label="修改密碼">
          <Form.Item
            name="password1"
            rules={[{ required: true, message: "修改密碼不可為空" }]}
          >
            <Input placeholder="請輸入修改密碼" />
          </Form.Item>

          <Form.Item
            name="password2"
            dependencies={["password1"]}
            rules={[
              { required: true, message: "請再次輸入修改密碼" },
              {
                validator(_, value: string) {
                  if (value.length && value !== form.getFieldValue("password1"))
                    return Promise.reject("確認修改密碼不一致");
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="請再次輸入修改密碼" />
          </Form.Item>
        </Form.Item>

        <div className="flex jc:end">
          <Button type="primary" htmlType="submit">
            送出
          </Button>
        </div>
      </Form>
    </div>
  );
};
